export default __webpack_public_path__ + "static/media/hs2.0fc16aa6.png";